import { startButtonLoading } from './form_submit_guard';

const LOADING_CLASS = 'available-products__continue-button--loading';

// Redeeming creates contracts, so the round trip is long enough that a bare
// click reads as a dead button and invites a second one. Submit-only: unlike
// the sign-in guard there is no field to gate on, since the workspace select
// always carries a selection.
export const initAvailableProductsSubmitGuard = () => {
  const form = document.querySelector('.available-products__continue-form');
  if (!form) return;

  const submitButton = form.querySelector('[type="submit"]');
  if (!submitButton) return;

  form.addEventListener('submit', () => startButtonLoading(submitButton, LOADING_CLASS));
};
